import {Link} from 'react-router-dom';
import React, { useContext } from 'react';
import {WebContext} from '../webcontext';
import moment from 'moment';

import WebPlayer from './webplayer';

import 'hero-slider/dist/index.css';
import HeroSlider, { Nav, Overlay, Slide } from 'hero-slider';

export default function HomePage() {
  const service = useContext(WebContext);
  //console.log(service), 

  let date = Math.floor(new Date().getTime()/1000);

  const schedule = service.web?.schedule.map((e, i) => {
    return e.events.map((f, j) => {
      let start = Math.floor(new Date(f.start)/1000);
      //console.log(i, j);
      if( date - 3600 > start)
        return (
          <Link key={j} to={`/ourdjs/${j}`} data-nav="" className="card schedule-card now-playing-card">
            <img src={`https://cloud.ultrastream.io${f.avatar}?d=${Math.floor(Date.now()/1000)}`} alt="Andy Adams" className="card-img" />
            <div className="card-body">
              <span className="card-time">On Air</span>
              <h3 className="card-title" style={{color: 'var(--accent-coral)'}}>{f.djtitle?f.djtitle:f.title?f.title:f.username}</h3>
              <p className="card-subtitle">{f.djtitle?f.djtitle:f.title?f.title:f.username} - Chronical Vibe LIVE - Thirsty Thursday - House bangers - 30/04/2026</p>
            </div>
          </Link>
        )
      else return null;
    })
  }).flat();


  switch(service.web?.service.template) {
    case 2:
      return (
        <main id="content-area" className="content-area" style={{opacity: 1}}>
          <div data-page-title="Home">

              
            <section className="hero-banner" x-data="heroBanner()" x-init="start()">
              <div className="hero-slides">
                <HeroSlider className='h-full w-full' autoplay>
                  <Slide
                    shouldRenderMask
                    background={{
                      backgroundImageSrc: '/images/2/banners/banner-10.png'
                    }}
                  />
                  <Slide
                    shouldRenderMask
                    background={{
                      backgroundImageSrc: '/images/2/banners/banner-11.png'
                    }}
                  />
                  <Slide
                    shouldRenderMask
                    background={{
                      backgroundImageSrc: '/images/2/banners/banner-12.png'
                    }}
                  />
                  <Slide
                    shouldRenderMask
                    background={{
                      backgroundImageSrc: '/images/2/banners/banner-13.png'
                    }}
                  />
                  <Slide
                    shouldRenderMask
                    background={{
                      backgroundImageSrc: '/images/2/banners/banner-15.png'
                    }}
                  />
                  <Slide
                    shouldRenderMask
                    background={{
                      backgroundImageSrc: '/images/2/banners/banner-16.png'
                    }}
                  />
                </HeroSlider>
              </div>
              <div className="hero-banner-content">
                <h1>The Best DJs.<br />The Best Music.<br /><span className="text-coral">24/7</span></h1>
                <p className="hero-sub">Online house music radio, created by DJs, for DJs. Soulful, funky, disco, tech, progressive and more — from 40+ DJs around the world.</p>
                <div className="hero-actions">
                  <Link to="/schedule" data-nav="" className="btn btn-filled">View Schedule</Link>
                  <Link to="/ourdjs" data-nav="" className="btn">Meet the DJs</Link>
                  <Link to="/joinus" data-nav="" className="btn btn-ghost">Join the Family</Link>
                </div>
              </div>
              <div className="hero-banner-visual">
                {service.web?.schedule.map((e, i) => {
                  if( e.avatar )
                    return (
                      <img key={i} src={`${e.avatar}?d=${Math.floor(Date.now()/1000)}`} alt="Today's Lineup" className="hero-flyer" />
                    )
                  else return null;
                })}
              </div>
            </section>
            
            
            <section className="up-next">
              <h2 className="section-title">On Air &amp,Up Next</h2>
              <div className="up-next-scroll">
                {schedule.filter((item, index) => index < 4)}
              </div>
            </section>
            
            
            {/* Upcoming Event
            <section className="card mb-3" style={{padding:0, overflow:'hidden'}}>
              <div style={{display:'flex', gap:0, flexWrap:'wrap'}}>
                <div  style={{flex:1, minWidth:280, position:'relative', background:'#0a0e17'}}>
                  <template x-for="(img, i) in images" key="img">
                      <img src="img" alt="Event" style={{width:'100%', aspectRatio:1, objectFit:'cover', display:'block'}} loading="lazy" />
                  </template>
                  <img src="img" alt="Event" style={{width: '100%', aspectRatio: 1 / 1, objectFit: 'cover'}} loading="lazy" src="/site-images/events/4/event_cover.png" className="" />
                  <img src="img" alt="Event" style={{width: '100%', aspectRatio: 1 / 1, objectFit: 'cover', display: 'none'}} loading="lazy" src="/site-images/events/4/schedule_day1.png" className="" />
                  <img src="img" alt="Event" style={{width: '100%', aspectRatio: 1 / 1, objectFit: 'cover', display: 'none'}} loading="lazy" src="/site-images/events/4/schedule_day2.png" className="" />
                  <img src="img" alt="Event" style={{width: '100%', aspectRatio: 1 / 1, objectFit: 'cover', display: 'none'}} loading="lazy" src="/site-images/events/4/schedule_day3.png" className="" />
                  {/*}
                  <div style={{position:'absolute', 'bottom:0.5rem', left:'50%', transform:'translateX(-50%)', display:'flex', gap:'0.3rem'}}>

                      <template x-for="(img, i) in images" key="'dot-' + i">
                          <span style={{width:8, height:8, borderRadius:'50%', cursor:pointer}} style={{i === current ? 'background:var(--accent-coral)' : 'background:rgba(255,255,255,0.4)'" ></span>
                      </template><span style={{background:'var(--accent-coral)'}} ></span><span style={{background:rgba(255,255,255,0.4)" style={{i === current ? 'background:var(--accent-coral)' : 'background:rgba(255,255,255,0.4)'" ></span><span style={{background:rgba(255,255,255,0.4)" style={{i === current ? 'background:var(--accent-coral)' : 'background:rgba(255,255,255,0.4)'" ></span><span style={{background:rgba(255,255,255,0.4)" style={{i === current ? 'background:var(--accent-coral)' : 'background:rgba(255,255,255,0.4)'" ></span>
                      </div>
                      /}
                    
                </div>
                <div style={{flex:1, minWidth:280, padding:'1.5rem', display:'flex', flexDirection:'column', justifyContent:'center'}}>
                  <p style={{fontSize:'0.8rem', textTransform:'uppercase', letterSpacing:'0.1em', color:'var(--accent-gold)', margin:'0 0 0.5rem'}}>
                    <i className="fas fa-star"></i> Upcoming Event
                  </p>
                  <h2 style={{margin:'0 0 0.5rem', fontSize:'1.5rem'}}>Pride Support Stream</h2>
                  <p style={{fontSize:'0.95rem', color:'var(--accent-coral)', margin:'0 0 0.75rem'}}>
                    <i className="fas fa-calendar-alt"></i> 26/06/2026 - 28 June 2026
                  </p>
                    <p style={{fontSize:'0.9rem', margin:'0 0 1rem', lineHeight:1.5, opacity:0.9}}>
                      A weekend stream to show support for Pride Month, as we do every year ;-)
                    </p>
                  <div>
                    <a href="/events" data-nav="" className="btn btn-filled">View Event Details</a>
                  </div>
                </div>
              </div>
            </section>*/}
            

            {/* Listen on the move / mobile
            <section className="app-promo">
              <div className="app-promo-copy">
                <p className="app-promo-eyebrow"><i className="fab fa-apple"></i> Now on iOS, <i className="fab fa-android"></i> Android &amp,<i className="fas fa-tv"></i> Roku</p>
                <h2 className="app-promo-title">Take 4TheMusic anywhere</h2>
                <p className="app-promo-desc">Listen live on the go on iPhone or Android, or watch on the big screen on Roku — follow your favourite DJs and chat with the community wherever you are.</p>
              </div>
              <div className="app-promo-badges">
                <a href="https://apps.apple.com/us/app/4-the-music-radio/id6456125970" target="_blank" className="play-badge play-badge-lg">
                  <i className="fab fa-apple"></i>
                  <span>
                    <small>Download on the</small>
                    <strong>App Store</strong>
                  </span>
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.fourthemusic" target="_blank" className="play-badge play-badge-lg">
                  <i className="fab fa-google-play"></i>
                  <span>
                    <small>GET IT ON</small>
                    <strong>Google Play</strong>
                  </span>
                </a>
                <a href="https://channelstore.roku.com/details/e94b40970590a913536a5dff9bcc4fad:85b2f25690033349bb881f84c7d23f82/4-the-music" target="_blank" className="roku-badge roku-badge-lg">
                  <span className="roku-badge-action">
                    <small>ADD TO</small>
                    <img src="/images/roku-logo-white.svg" alt="Roku" className="roku-badge-logo" />
                  </span>
                </a>
              </div>
            </section>
            */}

            
            {/* Spotify
            <section className="mb-3">
              <div style={{display:'flex',alignItems:'baseline',justifyContent:'space-between',gap:'1rem',flexWrap:'wrap',marginBottom:'0.75rem'}}>
                <h2 className="section-title" style={{margin:0}}>
                  <i className="fab fa-spotify" style={{color:'#1DB954'}}></i> On Spotify
                </h2>
                <a href="/listen" data-nav="" className="btn btn-sm btn-ghost">
                  All playlists <i className="fas fa-arrow-right"></i>
                </a>
              </div>
              <p className="text-secondary" style={{margin:'0 0 0.75rem',fontSize:'0.95rem'}}>
                Curated from live DJ mixes — refreshed weekly.
              </p>
              <div className="spotify-home-grid">
                <a href="https://open.spotify.com/playlist/20AMv3CRVo7sHkhUGL0flm" target="_blank" rel="noopener" title="4TheMusic Deep House on Spotify" className="spotify-home-card">
                  <img src="/site-images/spotify-covers/deep-house.jpg" alt="4TheMusic Deep House cover" loading="lazy" />
                  <div className="spotify-home-overlay">
                    <span className="spotify-home-name">4TheMusic Deep House</span>
                    <span className="spotify-home-cta"><i className="fab fa-spotify"></i> Spotify</span>
                  </div>
                </a>
                <a href="https://open.spotify.com/playlist/4kfGaGVvMKnQuGu17PDmNr" target="_blank" rel="noopener" title="4TheMusic Disco House on Spotify" className="spotify-home-card">
                  <img src="/site-images/spotify-covers/disco-nu-disco.jpg" alt="4TheMusic Disco House cover" loading="lazy" />
                  <div className="spotify-home-overlay">
                    <span className="spotify-home-name">4TheMusic Disco House</span>
                    <span className="spotify-home-cta"><i className="fab fa-spotify"></i> Spotify</span>
                  </div>
                </a>
                <a href="https://open.spotify.com/playlist/5bWFpojt0qxHBbmDdV3MMN" target="_blank" rel="noopener" title="4TheMusic House Sessions on Spotify" className="spotify-home-card">
                  <img src="/site-images/spotify-covers/house.jpg" alt="4TheMusic House Sessions cover" loading="lazy" />
                  <div className="spotify-home-overlay">
                    <span className="spotify-home-name">4TheMusic House Sessions</span>
                    <span className="spotify-home-cta"><i className="fab fa-spotify"></i> Spotify</span>
                  </div>
                </a>
                <a href="https://open.spotify.com/playlist/4GEcRXKfSi0TcHlHpBp0lv" target="_blank" rel="noopener" title="4TheMusic Indie Dance on Spotify" className="spotify-home-card">
                  <img src="/site-images/spotify-covers/indie-dance.jpg" alt="4TheMusic Indie Dance cover" loading="lazy" />
                  <div className="spotify-home-overlay">
                    <span className="spotify-home-name">4TheMusic Indie Dance</span>
                    <span className="spotify-home-cta"><i className="fab fa-spotify"></i> Spotify</span>
                  </div>
                </a>
                <a href="https://open.spotify.com/playlist/3QFzMKvrqwTn0S3LrjecTv" target="_blank" rel="noopener" title="4TheMusic Soulful House on Spotify" className="spotify-home-card">
                  <img src="/site-images/spotify-covers/soulful-jazzy.jpg" alt="4TheMusic Soulful House cover" loading="lazy" />
                  <div className="spotify-home-overlay">
                    <span className="spotify-home-name">4TheMusic Soulful House</span>
                    <span className="spotify-home-cta"><i className="fab fa-spotify"></i> Spotify</span>
                  </div>
                </a>
                <a href="https://open.spotify.com/playlist/3a6jAW3pU5Aj6wYB7UZEYu" target="_blank" rel="noopener" title="4TheMusic Tech House on Spotify" className="spotify-home-card">
                  <img src="/site-images/spotify-covers/tech-house.jpg" alt="4TheMusic Tech House cover" loading="lazy" />
                  <div className="spotify-home-overlay">
                    <span className="spotify-home-name">4TheMusic Tech House</span>
                    <span className="spotify-home-cta"><i className="fab fa-spotify"></i> Spotify</span>
                  </div>
                </a>
              </div>
              {/*
              <style>
                  .spotify-home-grid {
                      display: grid;
                      grid-template-columns: repeat(6, 1fr);
                      gap: 0.75rem;
                  }
                  @media (max-width: 900px) { .spotify-home-grid { grid-template-columns: repeat(3, 1fr),} }
                  @media (max-width: 480px) { .spotify-home-grid { grid-template-columns: repeat(2, 1fr),} }
                  .spotify-home-card {
                      position: relative,display: block,aspect-ratio: 1;
                      border-radius: 10px,overflow: hidden,text-decoration: none;
                      background: var(--bg-card-hover, #2a3444);
                      transition: transform 0.15s, box-shadow 0.15s;
                  }
                  .spotify-home-card:hover {
                      transform: translateY(-2px);
                      box-shadow: 0 6px 16px rgba(29,185,84,0.25);
                  }
                  .spotify-home-card img { width: 100%,height: 100%,object-fit: cover,display: block,}
                  .spotify-home-placeholder { width: 100%,height: 100%,display: flex,align-items: center,justify-content: center,font-size: 2rem,color: #1DB954,}
                  .spotify-home-overlay {
                      position: absolute,left: 0,right: 0,bottom: 0;
                      padding: 0.45rem 0.5rem;
                      background: linear-gradient(to top, rgba(0,0,0,0.85) 40%, rgba(0,0,0,0));
                      color: #fff,display: flex,flex-direction: column,gap: 0.1rem;
                  }
                  .spotify-home-name { font-weight: 600,font-size: 0.7rem,line-height: 1.15,}
                  .spotify-home-cta { font-size: 0.6rem,color: #1DB954,display: inline-flex,align-items: center,gap: 0.25rem,}
              </style>
              /}
            </section>
            */}

             
            <div className="grid-2 chart-equal">
              <section>
                <h2 className="section-title">Latest Mix Uploads</h2>
                <div className="card">
                  <a href="/dj/13447/dj-grampa-kempa?mix=16524" data-nav="" className="chart-item chart-item-link">
                    <img src="/cms/639180023174277517_cover_13447.png" alt="DJ Grampa Kempa" className="chart-img" loading="lazy" />
                    <div className="chart-info">
                      <p className="chart-title">Eindhoven Eclectic - The History of Eindhoven part 2</p>
                      <p className="chart-dj">DJ Grampa Kempa</p>
                      <div className="mix-tags">
                        <span className="tag">tech house</span>
                      </div>
                    </div>
                    <div className="mix-stats">
                      <span><i className="fas fa-headphones"></i> 0</span>
                      <span><i className="fas fa-heart"></i> 0</span>
                    </div>
                  </a>
                  <a href="/dj/13130/dubpl8z?mix=16523" data-nav="" className="chart-item chart-item-link">
                    <img src="/cms/638731413510656667_4tm-new-profile.png" alt="Dubpl8z" className="chart-img" loading="lazy" />
                    <div className="chart-info">
                      <p className="chart-title">After Dark - 23-06-2026 - Acid Techno</p>
                      <p className="chart-dj">Dubpl8z</p>
                      <div className="mix-tags">
                        <span className="tag">acid techno</span>
                        <span className="tag">dark techno</span>
                        <span className="tag">hard techno</span>
                        <span className="tag">industrial techno</span>
                      </div>
                    </div>
                    <div className="mix-stats">
                      <span><i className="fas fa-headphones"></i> 8</span>
                      <span><i className="fas fa-heart"></i> 17</span>
                    </div>
                  </a>
                  <a href="/dj/13438/danlys8?mix=16522" data-nav="" className="chart-item chart-item-link">
                      <img src="/cms/639178356872166361_cover_13438.png" alt="Danlys8" className="chart-img" loading="lazy" />
                      <div className="chart-info">
                          <p className="chart-title">Giving Luv Tuesday</p>
                          <p className="chart-dj">Danlys8</p>
                          <div className="mix-tags">
                                  <span className="tag">Progressive EDM</span>
                          </div>
                      </div>
                      <div className="mix-stats">
                          <span><i className="fas fa-headphones"></i> 28</span>
                          <span><i className="fas fa-heart"></i> 16</span>
                      </div>
                  </a>
                  <a href="/dj/13210/rob-murray?mix=16521" data-nav="" className="chart-item chart-item-link">
                      <img src="/cms/639178343097081177_cover_13210.png" alt="Rob Murray" className="chart-img" loading="lazy" />
                      <div className="chart-info">
                          <p className="chart-title">After Dark - 23.06.2026</p>
                          <p className="chart-dj">Rob Murray</p>
                          <div className="mix-tags">
                                  <span className="tag">acid</span>
                                  <span className="tag">acid house</span>
                                  <span className="tag">indietronica</span>
                                  <span className="tag">indie dance / alternative dance</span>
                          </div>
                      </div>
                      <div className="mix-stats">
                          <span><i className="fas fa-headphones"></i> 17</span>
                          <span><i className="fas fa-heart"></i> 17</span>
                      </div>
                  </a>
                  <a href="/dj/13397/ronald-vasquez?mix=16520" data-nav="" className="chart-item chart-item-link">
                      <img src="/cms/639176990332331254_cover_13397.png" alt="Ronald Vasquez" className="chart-img" loading="lazy" />
                      <div className="chart-info">
                          <p className="chart-title">Retro Mix  | SHOW Nº96 | 4TheMusic – RETRO MIX NUDISCO</p>
                          <p className="chart-dj">Ronald Vasquez</p>
                          <div className="mix-tags">
                                  <span className="tag">NuDisco</span>
                                  <span className="tag">house</span>
                          </div>
                      </div>
                      <div className="mix-stats">
                          <span><i className="fas fa-headphones"></i> 45</span>
                          <span><i className="fas fa-heart"></i> 27</span>
                      </div>
                  </a>
                  <a href="/dj/13292/kempton?mix=16519" data-nav="" className="chart-item chart-item-link">
                      <img src="/cms/639176674007465023_cover_13292.png" alt="Kempton" className="chart-img" loading="lazy" />
                      <div className="chart-info">
                          <p className="chart-title">Kempton - Cover Show 21.06.26</p>
                          <p className="chart-dj">Kempton</p>
                          <div className="mix-tags">
                                  <span className="tag">soulful house</span>
                          </div>
                      </div>
                      <div className="mix-stats">
                          <span><i className="fas fa-headphones"></i> 17</span>
                          <span><i className="fas fa-heart"></i> 21</span>
                      </div>
                  </a>
                  <a href="/dj/13457/grant-mac?mix=16518" data-nav="" className="chart-item chart-item-link">
                      <img src="/cms/13457_profile_639112426908868216.png" alt="Grant Mac" className="chart-img" loading="lazy" />
                      <div className="chart-info">
                          <p className="chart-title">Live Show 20-06-2026</p>
                          <p className="chart-dj">Grant Mac</p>
                          <div className="mix-tags">
                                  <span className="tag">Indie Dance</span>
                                  <span className="tag">Nu Disco</span>
                                  <span className="tag">Soulful House</span>
                                  <span className="tag">Deep House</span>
                          </div>
                      </div>
                      <div className="mix-stats">
                          <span><i className="fas fa-headphones"></i> 26</span>
                          <span><i className="fas fa-heart"></i> 19</span>
                      </div>
                  </a>
                  <a href="/dj/13404/andy-66?mix=16516" data-nav="" className="chart-item chart-item-link">
                      <img src="/cms/639174938177473971_cover_13404.png" alt="Andy 66" className="chart-img" loading="lazy" />
                      <div className="chart-info">
                          <p className="chart-title">Show 077 - Disco Fever Vol. 78</p>
                          <p className="chart-dj">Andy 66</p>
                          <div className="mix-tags">
                                  <span className="tag">Funky House</span>
                                  <span className="tag">Disco</span>
                                  <span className="tag">Nu-Disco</span>
                                  <span className="tag">Vocal House</span>
                          </div>
                      </div>
                      <div className="mix-stats">
                          <span><i className="fas fa-headphones"></i> 49</span>
                          <span><i className="fas fa-heart"></i> 25</span>
                      </div>
                  </a>
                  <a href="/dj/13456/lotte-on-the-dex?mix=16515" data-nav="" className="chart-item chart-item-link">
                      <img src="/cms/639174150953863040_cover_13456.png" alt="Lotte on the Dex" className="chart-img" loading="lazy" />
                      <div className="chart-info">
                          <p className="chart-title">Lotte's Lounge on Thursday 18th June</p>
                          <p className="chart-dj">Lotte on the Dex</p>
                          <div className="mix-tags">
                                  <span className="tag">Soulful house</span>
                                  <span className="tag">Afro House</span>
                                  <span className="tag">Deep House</span>
                                  <span className="tag">Uplifting House</span>
                          </div>
                      </div>
                      <div className="mix-stats">
                          <span><i className="fas fa-headphones"></i> 60</span>
                          <span><i className="fas fa-heart"></i> 23</span>
                      </div>
                  </a>
                  <a href="/dj/13447/dj-grampa-kempa?mix=16513" data-nav="" className="chart-item chart-item-link">
                      <img src="/cms/639173971350083619_cover_13447.png" alt="DJ Grampa Kempa" className="chart-img" loading="lazy" />
                      <div className="chart-info">
                          <p className="chart-title">Eindhoven Eclectic - The History of Eindhoven part 1</p>
                          <p className="chart-dj">DJ Grampa Kempa</p>
                          <div className="mix-tags">
                                  <span className="tag">disco</span>
                                  <span className="tag">nu-disco</span>
                                  <span className="tag">disco house</span>
                          </div>
                      </div>
                      <div className="mix-stats">
                          <span><i className="fas fa-headphones"></i> 9</span>
                          <span><i className="fas fa-heart"></i> 16</span>
                      </div>
                  </a>
                </div>
              </section>

              <section>
                  <h2 className="section-title">4TM Weekly Chart</h2>
                  <div className="card">
                          <a href="/dj/13404/andy-66?mix=16516" data-nav="" className="chart-item chart-item-link chart-pos-1">
                              <span className="chart-position">1</span>
                              <img src="/cms/639174938177473971_cover_13404.png" alt="Andy 66" className="chart-img" loading="lazy" />
                              <div className="chart-info">
                                  <p className="chart-title">Show 077 - Disco Fever Vol. 78</p>
                                  <p className="chart-dj">Andy 66</p>
                                  <div className="mix-tags">
                                          <span className="tag">Funky House</span>
                                          <span className="tag">Disco</span>
                                          <span className="tag">Nu-Disco</span>
                                          <span className="tag">Vocal House</span>
                                  </div>
                              </div>
                              <div className="mix-stats">
                                  <span><i className="fas fa-headphones"></i> 49</span>
                                  <span><i className="fas fa-heart"></i> 25</span>
                              </div>
                          </a>
                          <a href="/dj/13456/lotte-on-the-dex?mix=16515" data-nav="" className="chart-item chart-item-link chart-pos-2">
                              <span className="chart-position">2</span>
                              <img src="/cms/639174150953863040_cover_13456.png" alt="Lotte on the Dex" className="chart-img" loading="lazy" />
                              <div className="chart-info">
                                  <p className="chart-title">Lotte's Lounge on Thursday 18th June</p>
                                  <p className="chart-dj">Lotte on the Dex</p>
                                  <div className="mix-tags">
                                          <span className="tag">Soulful house</span>
                                          <span className="tag">Afro House</span>
                                          <span className="tag">Deep House</span>
                                          <span className="tag">Uplifting House</span>
                                  </div>
                              </div>
                              <div className="mix-stats">
                                  <span><i className="fas fa-headphones"></i> 60</span>
                                  <span><i className="fas fa-heart"></i> 23</span>
                              </div>
                          </a>
                          <a href="/dj/13397/ronald-vasquez?mix=16520" data-nav="" className="chart-item chart-item-link chart-pos-3">
                              <span className="chart-position">3</span>
                              <img src="/cms/639176990332331254_cover_13397.png" alt="Ronald Vasquez" className="chart-img" loading="lazy" />
                              <div className="chart-info">
                                  <p className="chart-title">Retro Mix  | SHOW Nº96 | 4TheMusic – RETRO MIX NUDISCO</p>
                                  <p className="chart-dj">Ronald Vasquez</p>
                                  <div className="mix-tags">
                                          <span className="tag">NuDisco</span>
                                          <span className="tag">house</span>
                                  </div>
                              </div>
                              <div className="mix-stats">
                                  <span><i className="fas fa-headphones"></i> 45</span>
                                  <span><i className="fas fa-heart"></i> 27</span>
                              </div>
                          </a>
                          <a href="/dj/13210/rob-murray?mix=16521" data-nav="" className="chart-item chart-item-link ">
                              <span className="chart-position">4</span>
                              <img src="/cms/639178343097081177_cover_13210.png" alt="Rob Murray" className="chart-img" loading="lazy" />
                              <div className="chart-info">
                                  <p className="chart-title">After Dark - 23.06.2026</p>
                                  <p className="chart-dj">Rob Murray</p>
                                  <div className="mix-tags">
                                          <span className="tag">acid</span>
                                          <span className="tag">acid house</span>
                                          <span className="tag">indietronica</span>
                                          <span className="tag">indie dance / alternative dance</span>
                                  </div>
                              </div>
                              <div className="mix-stats">
                                  <span><i className="fas fa-headphones"></i> 17</span>
                                  <span><i className="fas fa-heart"></i> 17</span>
                              </div>
                          </a>
                          <a href="/dj/13292/kempton?mix=16519" data-nav="" className="chart-item chart-item-link ">
                              <span className="chart-position">5</span>
                              <img src="/cms/639176674007465023_cover_13292.png" alt="Kempton" className="chart-img" loading="lazy" />
                              <div className="chart-info">
                                  <p className="chart-title">Kempton - Cover Show 21.06.26</p>
                                  <p className="chart-dj">Kempton</p>
                                  <div className="mix-tags">
                                          <span className="tag">soulful house</span>
                                  </div>
                              </div>
                              <div className="mix-stats">
                                  <span><i className="fas fa-headphones"></i> 17</span>
                                  <span><i className="fas fa-heart"></i> 21</span>
                              </div>
                          </a>
                          <a href="/dj/13457/grant-mac?mix=16518" data-nav="" className="chart-item chart-item-link ">
                              <span className="chart-position">6</span>
                              <img src="/cms/13457_profile_639112426908868216.png" alt="Grant Mac" className="chart-img" loading="lazy" />
                              <div className="chart-info">
                                  <p className="chart-title">Live Show 20-06-2026</p>
                                  <p className="chart-dj">Grant Mac</p>
                                  <div className="mix-tags">
                                          <span className="tag">Indie Dance</span>
                                          <span className="tag">Nu Disco</span>
                                          <span className="tag">Soulful House</span>
                                          <span className="tag">Deep House</span>
                                  </div>
                              </div>
                              <div className="mix-stats">
                                  <span><i className="fas fa-headphones"></i> 26</span>
                                  <span><i className="fas fa-heart"></i> 19</span>
                              </div>
                          </a>
                          <a href="/dj/13438/danlys8?mix=16522" data-nav="" className="chart-item chart-item-link ">
                              <span className="chart-position">7</span>
                              <img src="/cms/639178356872166361_cover_13438.png" alt="Danlys8" className="chart-img" loading="lazy" />
                              <div className="chart-info">
                                  <p className="chart-title">Giving Luv Tuesday</p>
                                  <p className="chart-dj">Danlys8</p>
                                  <div className="mix-tags">
                                          <span className="tag">Progressive EDM</span>
                                  </div>
                              </div>
                              <div className="mix-stats">
                                  <span><i className="fas fa-headphones"></i> 28</span>
                                  <span><i className="fas fa-heart"></i> 16</span>
                              </div>
                          </a>
                          <a href="/dj/13130/dubpl8z?mix=16523" data-nav="" className="chart-item chart-item-link ">
                              <span className="chart-position">8</span>
                              <img src="/cms/638731413510656667_4tm-new-profile.png" alt="Dubpl8z" className="chart-img" loading="lazy" />
                              <div className="chart-info">
                                  <p className="chart-title">After Dark - 23-06-2026 - Acid Techno</p>
                                  <p className="chart-dj">Dubpl8z</p>
                                  <div className="mix-tags">
                                          <span className="tag">acid techno</span>
                                          <span className="tag">dark techno</span>
                                          <span className="tag">hard techno</span>
                                          <span className="tag">industrial techno</span>
                                  </div>
                              </div>
                              <div className="mix-stats">
                                  <span><i className="fas fa-headphones"></i> 8</span>
                                  <span><i className="fas fa-heart"></i> 17</span>
                              </div>
                          </a>
                          <a href="/dj/13447/dj-grampa-kempa?mix=16524" data-nav="" className="chart-item chart-item-link ">
                              <span className="chart-position">9</span>
                              <img src="/cms/639180023174277517_cover_13447.png" alt="DJ Grampa Kempa" className="chart-img" loading="lazy" />
                              <div className="chart-info">
                                  <p className="chart-title">Eindhoven Eclectic - The History of Eindhoven part 2</p>
                                  <p className="chart-dj">DJ Grampa Kempa</p>
                                  <div className="mix-tags">
                                          <span className="tag">tech house</span>
                                  </div>
                              </div>
                              <div className="mix-stats">
                                  <span><i className="fas fa-headphones"></i> 0</span>
                                  <span><i className="fas fa-heart"></i> 0</span>
                              </div>
                          </a>
                  </div>
              </section>
            </div>

              
            <section className="cta-section">
              <h2>Listen Now</h2>
              <p>Tune in 24/7 on your favourite platform.</p>
              <div className="hero-actions" style={{justifyContent:'center'}}>
                <iframe src="https://embed.ultrastream.io/us_UqdniLFxKwQQPICBS" id="us_UqdniLFxKwQQPICBS" width="100%"></iframe>
              </div>
            </section>

          </div>

        </main>
      )
    case 1:
      return (
        <>
          <section className="hero-section-version1 zindex1 position-relative">
            <div className="container">
              <div className="hero-v1-content text-center">
                <span className="listing-text">
                  <img src="/images/listing-text.webp" alt="img" />
                </span>
                <h1 className="hero-title white-clr text-uppercase mb-xxl-13 mb-xl-10 mb-lg-8 mb-md-7 mb-sm-7 mb-6">
                  To Us Daily
                </h1>
                <div className="hero-tag">
                  {service.web?.platforms.map((e, i)=>{
                    return (
                      <a key={i} href={e.website} target="_blank" rel="noreferrer" className="hero-tag-item theme-bg d-flex align-items-center gap-2 py-xxl-3 py-2 px-xxl-8 px-xl-6 px-5">
                        <i className="ph-fill ph-soundcloud-logo fs20"></i>
                        <span className="fs12 fw-700 body-font white-clr text-uppercase">
                          {e.platform}
                        </span>
                      </a>
                    )
                  })}
                </div>
                <img src="/images/bn-arrowv1.webp" alt="img" className="bn-arrowv1" />
              </div>
            </div>
          </section>
          
          <WebPlayer />
          
          
          <main className="main position-relative overflow-hidden" id="mains">
            <section className="blog-details-section whitebg pt-space pb-space">
              <div className="container">
                <div className="row justify-content-center g-xxl-6 g-4">
                  {service.web?.schedule.slice(0, 3).map((e, i) => {
                    return (
                      <div key={i} className="col-lg-4 col-md-6 col-sm-6 aos-init aos-animate" data-aos="fade-up" data-aos-duration="500">
                        <div className="blog-widget-item">
                          <div className="thumb position-relative">
                            <img src={e.avatar ? `https://cloud.ultrastream.io${e.avatar}` : `/images/radio-banner-with-live-music_1419-1987.jpg`} alt="img" className="overflow-hidden" />
                            <div className="date-box theme-bg text-uppercase fs12 white-clr text-center d-grid align-items-center justify-content-center">
                              <span>
                                {moment(e.date).format("DD")}
                                <span className="april text-uppercase d-block fs12">
                                  {moment(e.date).format("MMMM")}
                                </span>
                              </span>
                            </div>
                          </div>
                          <div className="content p-3">
                            <div className="d-flex align-items-center gap-xxl-4 gap-xl-3 gap-2 mb-xxl-4 mb-3">
                              {/*<a href="#" className="d-flex align-items-center gap-2">
                                <i className="ph-fill ph-user-circle theme-clr fs18"></i>
                                <span className="pra-clr d-block fs14">
                                  by Admin
                                </span>
                              </a>
                              <a href="#" className="d-flex align-items-center gap-2">
                                <i className="ph-fill ph-chats-teardrop theme-clr fs18"></i>
                                <span className="pra-clr d-block fs14">
                                  02 Comments
                                </span>
                              </a>*/}
                            </div>
                            <h5 className="">
                              <Link to={'/schedule'} className="black-clr fw-700">
                                {e.showname ? e.showname : moment(e.date).format("DD MMM, YYYY")}
                              </Link>
                            </h5>
                          </div>
                          <div className="content p-3">
                            {e.events.slice(0, 5).map((f, j)=>{
                              return (
                                <div key={j} className="d-flex align-items-center">
                                  <div className="p-1">
                                    <img src={`https://cloud.ultrastream.io${f.avatar}`} width="56" alt="User Avatar" />
                                  </div>
                                  <div className="black-clr fw-700 ps-3" style={{lineHeight: '20px'}}>
                                    {f.title ? f.title : f.djtitle ? f.djtitle : f.username}<br />
                                    <span className="pra-clr d-block fs14">
                                      {moment(f.start).format("h:mm A")} - {moment(f.end).format("h:mm A")}
                                    </span>
                                  </div>
                                </div>
                              )
                            })}
                          </div>
                          <div className="content p-3">
                            <Link to={'/schedule'} className="view-all d-flex align-items-center gap-2 text-uppercase">
                              View All
                              <i className="ph-bold ph-arrow-right"></i>
                            </Link>
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </section>
          </main>
        </>
      )
    default:
      return (<></>)
  }

  
}
